export default {
  data: [],
  currentPage: {},
  currentLang: 'it',
};
